<template>
  <div class="viz-filter">
    <div class="viz-filter__info">
      <div class="label">{{ content.filter.info.label }}</div>
      <div class="icon" @click="showInfo">
        <svgicon
          class="icon-info"
          icon="icon-info"
          width="13"
          height="13"
          color="#000000"
        ></svgicon>
      </div>
    </div>
    <div class="viz-filter__label">{{ content.filter.dimensions }}</div>
    <div
      v-for="(el, elIndex) in config.dimensions"
      :key="el"
      :class="[
        'viz-filter__option',
        {
          last: elIndex === config.dimensions.length - 1,
          selected: el === getFilterViz
        }
      ]"
      @click="setFilterViz(el)"
    >
      <div
        class="viz-filter__option__check"
        :class="{ selected: el === getFilterViz }"
      >
        <div class="dot" v-if="el === getFilterViz"></div>
      </div>
      {{ content.filter.options[el] }}
    </div>
    <div
      v-if="normalizer.length"
      class="viz-filter__label"
      v-show-slide="
        (getVizElSelected && getVizElSelected.depth < 3) ||
          getVizElSelected === null
      "
    >
      {{ content.filter.normalize }}
    </div>
    <div
      v-for="(el, elIndex) in normalizer"
      :key="el"
      @click="manageClick(el, elIndex)"
      :class="[
        'viz-filter__option',
        {
          selected:
            getNormalizeViz &&
            elIndex + selectionOffset == getNormalizeViz.index,
          last: elIndex === normalizer.length - 1
        }
      ]"
    >
      <div
        class="viz-filter__option__check"
        :class="{
          selected:
            getNormalizeViz &&
            elIndex + selectionOffset == getNormalizeViz.index
        }"
      >
        <div
          class="dot"
          v-if="
            getNormalizeViz &&
              elIndex + selectionOffset == getNormalizeViz.index
          "
        ></div>
      </div>
      {{ content.filter.options[el] }}
    </div>
    <div class="viz-filter__help">
      <div class="label">{{ content.filter.info.help.label }}</div>
      <div class="action" @click="goToTutorial">
        {{ content.filter.info.help.cta }}
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/assets/content/config.json";
import { mapActions, mapGetters } from "vuex";
import genericQueryMethods from "@/mixins/genericQueryMethods";
import "../../compiled-icons/icon-check";
import "../../compiled-icons/icon-info";

export default {
  mixins: [genericQueryMethods],
  data() {
    return {
      config: config.viz.filter
    };
  },
  computed: {
    content() {
      return this.$ml.get("dataviz");
    },
    normalizer() {
      if (this.getVizElSelected === null) {
        return this.config.normalize;
      } else {
        if (this.getVizElSelected.depth === 3) {
          //hide normailze for scene when canto is selected
          return this.config.normalize.slice(this.getVizElSelected.depth + 1);
        } else {
          return this.config.normalize.slice(this.getVizElSelected.depth);
        }
      }
    },
    selectionOffset() {
      //ElmentIndex riscalato per la selezione corrente
      return this.getVizElSelected ? this.getVizElSelected.depth : 0;
    },
    ...mapGetters(["getFilterViz", "getNormalizeViz", "getVizElSelected"])
  },

  methods: {
    manageClick(el, elIndex) {
      // reset query
      // this.resetQuery();

      if (
        this.getNormalizeViz &&
        elIndex + this.selectionOffset === this.getNormalizeViz.index
      ) {
        this.setNormalizeViz(null);
      } else {
        this.setNormalizeViz({
          value: el,
          index: elIndex + this.selectionOffset
        });
      }
    },
    goToTutorial() {
      this.$router.push({
        name: "tutorial"
      });
    },
    showInfo() {
      this.$emit("showInfo");
    },
    ...mapActions(["setFilterViz", "setNormalizeViz"])
  }
};
</script>
<style lang="scss" scoped>
.viz-filter {
  width: 200px;
  position: fixed;
  top: 20px;
  right: 20px;
  border: solid 1px $white;
  z-index: $z-c;
  user-select: none;
  &::after {
    position: absolute;
    width: 100%;
    height: 100%;
    content: "";
    background: rgba(0, 0, 0, 0.2);
    z-index: -1;
    top: 0;
    backdrop-filter: blur(3px);
  }
  &__info {
    height: 28px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .label {
      color: $white;
      @include overlayS;
      text-transform: uppercase;
      padding-left: 12px;
      white-space: nowrap;
    }
    .icon {
      width: 30px;
      height: 100%;
      background-color: $white;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      flex-shrink: 0;

      .icon-info {
        opacity: 0.8;
        transition: opacity 0.2s;
      }
      &:hover {
        .icon-info {
          opacity: 1;
        }
      }
    }
  }
  &__label {
    color: $white;
    @include overlayS;
    text-transform: uppercase;
    width: 100%;
    padding: 14px 0 2px 12px;
    border-top: solid 1px $white;
    /* border-bottom: solid 1px $white;
    background-color: $white-50; */
  }
  &__option {
    color: $white-70;
    @include DidaL;
    height: 30px;
    padding: 0 15px 0 12px;
    display: flex;
    align-items: center;
    &.selected {
      color: $white;
    }
    &:hover {
      cursor: pointer;
      color: $white;
    }
    &.last {
      margin-bottom: 10px;
    }
    &__check {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: $white-70;
      flex-shrink: 0;
      margin-right: 7px;
      &.selected {
        background-color: $white;
      }
      .dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: $black-70;

        &:hover {
          background-color: $black;
        }
      }
    }
  }
  &__help {
    position: absolute;
    top: calc(100% + 15px);
    background: rgba(0, 0, 0, 0.2);
    width: 100%;
    height: 30px;
    backdrop-filter: blur(3px);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .label {
      color: $white;
      @include overlayS;
      text-transform: uppercase;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50%;
      border-top: solid 1px $white;
      border-left: solid 1px $white;
      border-bottom: solid 1px $white;
    }
    .action {
      color: $black-70;
      @include DidaL;
      font-weight: bold;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50%;
      background-color: $white;
      cursor: pointer;
      transition: color 0.2s;
      &:hover {
        color: #000;
      }
    }
  }
}
</style>
